export const Floor = (n: number, pos: number): number => {
  const digits = Math.pow(10, pos);
  const num = Math.floor(n * digits) / digits;
  return parseFloat(num.toFixed(pos));
};
